module.exports = __webpack_public_path__ + "img/ico-invoice.bb0171db.svg";